import { Indexed } from '../types/Indexed';

export function sortIndexed<T extends Indexed>(array: T[]) {
  return array.sort((a, b) => {
    return a.index - b.index;
  });
}
